import React from "react";
import { Link,NavLink } from "react-router-dom";
import "./card.scss";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';


export default function Card(props) {
  return (
    <div className="custom-card">
      <div className="img-wrapper">
        <img src={props.imagesrc} alt={props.imgAltText} className="img-fluid w-100"></img>
      </div>
      <div className="content-wrapper">
      {props.isClickable ? 
      <label className="heading" onClick={props.handleClick} data-pageId={props.redirectToPage}>{props.heading}</label>
      :
      <label className="heading">{props.heading}</label>
      }
        <p className={props.descriptionClass}>{props.description}</p>
        <button className={props.ButtonClass} onClick={props.handleCallToaction} data-id={props.doctorId}>{props.CTAText}<FontAwesomeIcon icon={props.fontIcon} /></button>
      </div>
    </div>
  );
}
